if (!customElements.get('scroll-feature-cards')) {
  customElements.define(
    'scroll-feature-cards',
    class ScrollFeatureCards extends HTMLElement {
      connectedCallback() {
        this.stack = this.querySelector('.scroll-feature-cards__stack');
        this.cards = Array.from(this.querySelectorAll('.scroll-feature-cards__stack > [data-scroll-card]'));
        if (!this.stack || this.cards.length < 2) return;

        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);
        this.ticking = false;

        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize, { passive: true });
        this.measure();
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        this.reset();
        if (this.stack) this.stack.style.height = '';
      }

      onResize() {
        this.measure();
        this.update();
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        window.requestAnimationFrame(() => {
          this.update();
          this.ticking = false;
        });
      }

      reset() {
        this.cards.forEach((card) => {
          card.style.position = '';
          card.style.top = '';
          card.style.left = '';
          card.style.width = '';
          card.style.transform = '';
          card.classList.remove('is-pinned');
        });
      }

      measure() {
        if (!this.stack || !this.cards.length) return;
        this.reset();
        this.stack.style.height = '';

        const first = this.cards[0];
        this.cardHeight = first.getBoundingClientRect().height;
        this.count = this.cards.length;

        if (this.cardHeight > 0) {
          this.stack.style.height = this.cardHeight * this.count + 'px';
        }
      }

      update() {
        if (!this.cardHeight) return;
        const stackRect = this.stack.getBoundingClientRect();
        const cardH = this.cardHeight;
        const scrolled = -stackRect.top;
        const viewportLeft = stackRect.left;

        this.cards.forEach((card, i) => {
          const pinStart = i * cardH;
          const pinEnd = (i + 1) * cardH;
          const isLast = i === this.count - 1;

          if (isLast || scrolled < pinStart) {
            card.style.position = 'absolute';
            card.style.top = pinStart + 'px';
            card.style.left = '0';
            card.style.width = '100%';
            card.classList.remove('is-pinned');
          } else if (scrolled < pinEnd) {
            card.style.position = 'fixed';
            card.style.top = '0px';
            card.style.left = viewportLeft + 'px';
            card.style.width = stackRect.width + 'px';
            card.classList.add('is-pinned');
          } else {
            card.style.position = 'absolute';
            card.style.top = pinStart + 'px';
            card.style.left = '0';
            card.style.width = '100%';
            card.classList.remove('is-pinned');
          }
        });
      }
    }
  );
}




